import { render, staticRenderFns } from "./ThePersonalModal.vue?vue&type=template&id=6359d7a2&scoped=true&"
import script from "./ThePersonalModal.vue?vue&type=script&lang=js&"
export * from "./ThePersonalModal.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalModal.vue?vue&type=style&index=0&id=6359d7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6359d7a2",
  null
  
)

export default component.exports